export type ToastKind = "success" | "error";

type Toast = {
  id: number;
  kind: ToastKind;
  message: string;
};

type Listener = () => void;

const NO_TOASTS: Toast[] = [];

let toasts: Toast[] = NO_TOASTS;
let nextToastId = 1;
const listeners = new Set<Listener>();

const emit = () => {
  for (const listener of listeners) {
    listener();
  }
};

export const toastStore = {
  subscribe: (listener: Listener) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },
  getSnapshot: (): Toast[] => toasts,
  getServerSnapshot: (): Toast[] => NO_TOASTS,
  push: (kind: ToastKind, message: string): void => {
    toasts = [{ id: nextToastId++, kind, message }, ...toasts];
    emit();
  },
  remove: (toastId: number): void => {
    toasts = toasts.filter((toast) => toast.id !== toastId);
    emit();
  },
};
